import {StrapiButtonProps} from '../models/strapi/strapi-button-props';
import {StrapiMeta} from '../models/strapi/strapi-meta';
import {useLanguageDependentDataSSr} from './useLanguageDependentDataSsr.hook';

export const useAccountManageWallet =
    useLanguageDependentDataSSr<UseAccountManageWalletData>('account-manage-wallet');

export interface UseAccountManageWalletData {
    headerTitle: string;
    headerDescription: string;
    chargeWalletButton: string;
    connectToMetaMaskButton: string;
    installMetaMaskPrompt: string;
    walletId: string;
    balance: string;
    disconnectButton: StrapiButtonProps;
    meta: StrapiMeta;
}